import { createContext, useState, useEffect, useCallback } from 'react';
import { getCurrentTheme, setTheme as setThemeUtil } from '../utils/themeColors.js';

const ThemeContext = createContext({
  theme: 'dark',
  setTheme: () => {},
  toggleTheme: () => {},
});

export function ThemeProvider({ children }) {
  // Initialize from current DOM state (set by initializeTheme in main.jsx)
  const [theme, setThemeState] = useState(() => getCurrentTheme());

  // Apply theme to document when it changes
  useEffect(() => {
    setThemeUtil(theme);
    
    // Dispatch event for non-React components
    window.dispatchEvent(new CustomEvent('themechange', { detail: theme }));
  }, [theme]);

  // Listen for external theme changes (e.g., from other tabs)
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'theme' && e.newValue) {
        setThemeState(e.newValue === 'light' ? 'light' : 'dark');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const setTheme = useCallback((newTheme) => {
    setThemeState(newTheme === 'light' ? 'light' : 'dark');
  }, []);

  const toggleTheme = useCallback(() => {
    setThemeState(prev => prev === 'dark' ? 'light' : 'dark');
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export default ThemeContext;
